import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from 'antd';
import { getRecordData } from 'utils/tools';
import { ImageWrapper } from './styles';

const RestImageField = (props) => {
  const value = getRecordData(props.record, props.source);
  if (value) {
    return props.type === 'avatar' ? (
      <Avatar alt="" src={value} />
    ) : (
      <ImageWrapper
        style={props.style}
        className={props.className}
        alt=""
        src={value}
      />
    );
  }
  return null;
};

RestImageField.propTypes = {
  type: PropTypes.string,
  source: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  record: PropTypes.object,
  style: PropTypes.any,
  className: PropTypes.string,
};
export default RestImageField;
